import * as React from 'react'
import useSWR from 'swr'
import {H1} from '@frontrow/console/src/components/typography'
import {
  fetchDemoDistrict,
  createOrRefreshDemoDistrict
} from '@frontrow/console/src/helpers/api-demo-district'
import {parseDemoDistrict} from '@frontrow/console/src/models/demo-district'
import Restricted from '@frontrow/console/src/components/common/restricted'
import SpinnerWrapper from '@frontrow/console/src/components/common/spinner-wrapper'
import DemoDistrictPage from '@frontrow/console/src/components/pages/demo-districts-page/demo-district-page'
import DemoDistrictManagement from '@frontrow/console/src/components/pages/demo-districts-page/demo-district-management'
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'

const DEMO_DISTRICT_SWR_KEY = 'demo-district'

export function DemoDistrictContainer(): React.ReactElement {
  const {
    data: demoDistrictData,
    isLoading,
    error,
    mutate
  } = useSWR(DEMO_DISTRICT_SWR_KEY, async () => {
    const response = await fetchDemoDistrict()
    return parseDemoDistrict(response)
  })

  const createOrResetDemoDistrict = React.useCallback(
    async () => {
      try {
        await createOrRefreshDemoDistrict()
        await mutate()
      } catch (err) {
        console.error('Error creating/resetting demo district:', err)
      }
    },
    // mutate has the SAME reference across renders
    [mutate]
  )

  const errorMessage = error?.message || error
  const errorNode = errorMessage ? <ErrorAlert>{errorMessage}</ErrorAlert> : null

  return (
    <React.Fragment>
      <H1>DEMO</H1>
      <SpinnerWrapper isLoading={isLoading}>
        {errorNode}
        <p>
          <strong>
            Personal demos use master demo data copied into a district that is private to you. You
            can change settings and data in your demo and it won't affect other users.
          </strong>
        </p>
        {demoDistrictData !== null && demoDistrictData !== undefined ? (
          <DemoDistrictPage
            demoDistrictData={demoDistrictData}
            createOrResetDemoDistrict={createOrResetDemoDistrict}
          />
        ) : null}
        <Restricted to="admin">
          <DemoDistrictManagement />
        </Restricted>
      </SpinnerWrapper>
    </React.Fragment>
  )
}
